import { render, staticRenderFns } from "./vue-checkbox.vue?vue&type=template&id=08ecd390&lang=html&"
import script from "./vue-checkbox.vue?vue&type=script&lang=js&"
export * from "./vue-checkbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports